module.exports = __webpack_public_path__ + "static/Climaider-d6622805acdfcf0596a2a3991c2abd60.jpg";